import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/auth/api";
import { alertSuccess, alertError } from "@/components/Alert";

// Fetch Tier List
export const fetchTierList = createAsyncThunk(
  "tier/fetchTierList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/location/panel/TierList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Tier
export const addTierList = createAsyncThunk(
  "tier/addTierList",
  async (newTierData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/TierList", newTierData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Tier
export const updateTierList = createAsyncThunk(
  "tier/updateTierList",
  async (tierData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/TierList", tierData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Tier Slice
const tierSlice = createSlice({
  name: "tier",
  initialState: {
    tierList: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchTierList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchTierList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.tierList = action.payload;
      })
      .addCase(fetchTierList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Add
      .addCase(addTierList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addTierList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addTierList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Update
      .addCase(updateTierList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateTierList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateTierList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = tierSlice.actions;
export default tierSlice.reducer;
